













import { Component, Vue } from "vue-property-decorator";
import LeftSide from "./LeftSide.vue";
import RightSide from "./RightSide.vue";

@Component({ components: { LeftSide, RightSide } })
export default class Welcome extends Vue {
    get card() {
        return this.$store.direct.state.insurance.card;
    }
}
